import { render, staticRenderFns } from "./NavBarForEdit.vue?vue&type=template&id=61046008&scoped=true&"
import script from "./NavBarForEdit.vue?vue&type=script&lang=js&"
export * from "./NavBarForEdit.vue?vue&type=script&lang=js&"
import style0 from "./NavBarForEdit.vue?vue&type=style&index=0&id=61046008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61046008",
  null
  
)

export default component.exports